/** Lowest catalog tier for each UI feature gate. A/B continue using their assigned offer. */
export function premiumFeatureTier(feature?: string): string | undefined {
  switch (feature) {
    case 'account':
    case 'themes': return 'tier_1';
    case 'history':
    case 'draw':
    case 'questions': return 'tier_2';
    case 'address':
    case 'organizers': return 'tier_3';
    default: return undefined;
  }
}

export function premiumFeatureAction(feature: string, language: string, price: string): string {
  const tier = premiumFeatureTier(feature);
  const ru = language.startsWith('ru');
  const name = tier === 'tier_3' ? (ru ? 'Санта-Магистром' : 'a Grandmaster')
    : tier === 'tier_2' ? (ru ? 'Санта-Мастером' : 'a Master') : (ru ? 'Волшебником' : 'a Wizard');
  return ru ? `Стать ${name} · ${price}` : `Become ${name} · ${price}`;
}
